<script lang="ts">
    import { createSlider } from '@melt-ui/svelte';
    import { createEventDispatcher, onMount } from 'svelte';

    import cn from '$common/utils/cn';

    export let label: string;
    export let valueMin: number;
    export let valueMax: number;
    export let defaultMin: number;
    export let defaultMax: number;

    const dispatch = createEventDispatcher<{
        change: { min: number; max: number };
    }>();

    let initialized = false;

    const {
        elements: { root, range, thumbs },
        states: { value },
    } = createSlider({
        defaultValue: [valueMin, valueMax],
        min: defaultMin,
        max: defaultMax,
        onValueChange: ({ next }) => {
            if (initialized) {
                dispatch('change', { min: next[0], max: next[1] });
            }

            return next;
        },
    });

    onMount(() => {
        initialized = true;
    });

    function onMinInput(event: Event) {
        const v = Number((event.target as HTMLInputElement).value);
        $value[0] = v;
        dispatch('change', { min: v, max: $value[1] });
    }

    function onMaxInput(event: Event) {
        const v = Number((event.target as HTMLInputElement).value);
        $value[1] = v;
        dispatch('change', { min: $value[0], max: v });
    }

    $: {
        $value = [valueMin, valueMax];
    }
</script>

<div class="flex flex-col">
    <div class="flex justify-between gap-xs">
        <div class="flex gap-2xs">
            <input
                class={cn('!min-h-[32px] !max-w-[100px] border-border-quiet')}
                value={valueMin}
                type="number"
                on:input={onMinInput}
            />
            <span class="self-center text-xs">{label}</span>
        </div>
        <div class="flex gap-2xs">
            <input
                class={cn('!min-h-[32px] !max-w-[100px] border-border-quiet')}
                value={valueMax}
                type="number"
                on:input={onMaxInput}
            />
            <span class="self-center text-xs">{label}</span>
        </div>
    </div>
    <span
        {...$root}
        use:root
        class="relative m-auto flex h-[40px] w-full items-center"
    >
        <span class="h-[2px] w-full bg-bord-quiet">
            <span {...$range} use:range class="h-[2px] bg-container-catchy"
            ></span>
        </span>

        {#each $thumbs as thumb, idx (idx)}
            <span
                {...thumb}
                use:thumb.action
                class={cn(
                    'focus:ring-container-catchy relative size-m cursor-pointer rounded-full bg-container-catchy focus:ring-4  focus:ring-black/20',
                )}
            >
            </span>
        {/each}
    </span>
</div>
